// extracted by mini-css-extract-plugin
export default {"galleryContainer":"ImageGallery_galleryContainer__ZLHWL","button":"ImageGallery_button__I+HG+"};